export const tokens = {
  green: '#00B061',
  red: '#F0162F',
  yellow: '#FFC700',
  blue: '#3434EA',
  cyan: '#008B8B',
  amber: '#f08416',
  tetherGreen: '#4d9a79',

  backgroundBase: '#000',
  backgroundSurface: '#0e0e0e',
  backgroundRaised: '#181818',
  backgroundElevated: '#222',

  textPrimary: '#ffffff',
  textSecondary: '#b2afaf',
  textTertiary: '#989898',
  textMuted: '#808080',
  textFaint: '#4d4d4d',

  fontSans: "'Kanit', sans-serif",
  fontDisplay: "'Bebas Neue', 'Kanit', sans-serif",
  fontMono: 'ui-monospace, SFMono-Regular, Menlo, monospace',

  borderCard: '1px solid rgba(128,128,128,0.35)',
  borderFaint: '1px solid rgba(128,128,128,0.15)',
} as const;

export type Tokens = typeof tokens;

export const isNeg = (value: string | number | null | undefined): boolean =>
  typeof value === 'string' && value.trim().startsWith('-');

export const profitColor = (
  value: string | number | null | undefined,
): string => (isNeg(value) ? tokens.red : tokens.green);
